import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import { getEmployeeSectionDataInitiate } from '../../actions/employee';
import Employees from './Employees';
import { getAllGroupsInitiate } from '../../actions/groups';
import { currentFlowTypeEnum } from '../common/components/constants';
import { getCompanyMappedOfficesInitiate } from '../../actions/company';

const mapStateToProps = state => {
  const employeesSecton = _get(state, 'employees', {});
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const viewOnlyMode = _get(state, 'user.view_only_mode', false);
  const currentFlow = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  return {
    currentFlow,
    viewOnlyMode,
    employeesSecton,
    selectedWorkspace,
    fetchingEmployeeSection:
      _get(state, 'apiState.GET_EMPLOYEE_SECTION.isFetching', true) &&
      !_get(state, 'apiState.GET_EMPLOYEE_SECTION.isIdle', false),
    fetchedEmployeeSection: _get(
      state,
      'apiState.GET_EMPLOYEE_SECTION.success',
      true,
    ),
  };
};

const mapDispatchToProps = dispatch => ({
  getEmployeeSection: payload =>
    dispatch(getEmployeeSectionDataInitiate(payload)),
  getAllGroups: payload => dispatch(getAllGroupsInitiate(payload)),
  getAllCompanyMappedOffices: payload =>
    dispatch(getCompanyMappedOfficesInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Employees);
